import "./index.scss";
import { ButtonIcon } from "@wise-emotions/react-button";
import {
  GeneralSmallArrowLeft,
  GeneralSmallArrowRight,
} from "@wise-emotions/react-icons";
import { useHorizontalScroll } from "components/hooks/useHorizontalScroll";
import React from "react";

export type TagGroupProps = {
  children: React.ReactNode;
};

const TagGroup = ({ children }: TagGroupProps) => {
  const { wrapperRef, scrollable, scrollLeft, scrollRight } =
    useHorizontalScroll(100);

  return (
    <div className="tag-group">
      {(scrollable.right || scrollable.left) && (
        <div className="tag-group__button">
          <ButtonIcon
            size="sm"
            ariaLabel="left"
            onClick={scrollLeft}
            disabled={!scrollable.left}
          >
            <GeneralSmallArrowLeft />
          </ButtonIcon>
        </div>
      )}
      <div
        ref={wrapperRef}
        className="tag-group__wrap"
        data-testid="ctaWrapper"
      >
        {Array.isArray(children) &&
          children.map((child) => {
            return (
              <div className="tag-group__item" key={child.props.id}>
                {child}
              </div>
            );
          })}
      </div>
      {(scrollable.right || scrollable.left) && (
        <div className="tag-group__button">
          <ButtonIcon
            size="sm"
            ariaLabel="right"
            onClick={scrollRight}
            disabled={!scrollable.right}
          >
            <GeneralSmallArrowRight />
          </ButtonIcon>
        </div>
      )}
    </div>
  );
};

export default TagGroup;
